module.exports = __webpack_public_path__ + "img/introduce_elephant.708599f0.webp";